/**
 * Labstep
 *
 * @module components/Protocol/Form/ShowEdit/State/Container
 * @desc State container
 */

import { ProtocolFormShowEditStateContainerEdit } from 'labstep-web/components/Protocol/Form/ShowEdit/State/Container/Edit';
import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import ProseMirrorDebouncingContainer from 'labstep-web/containers/ProseMirror/Debouncing';
import { MediaQueryMobile as Mobile } from 'labstep-web/core/MediaQuery/Mobile';
import type React from 'react';
import ProtocolFormShowEditState from '..';
import type { IProtocolFormShowEditStateContainerProps } from './types';

export const ProtocolFormShowEditStateContainer: React.FC<
  IProtocolFormShowEditStateContainerProps
> = ({ protocol, ...rest }) => (
  <EntityUpdateContainer
    entityName={protocol.entityName}
    id={protocol.id}
    optimistic
  >
    {({ update, status }): JSX.Element => (
      <Mobile>
        {(mobileContainerProps): JSX.Element => (
          <ProseMirrorDebouncingContainer
            entity={protocol}
            status={status}
            update={update as any}
          >
            {(debouncingContainerProps): JSX.Element => (
              <ProtocolFormShowEditStateContainerEdit
                entity={protocol}
              >
                {(editContainerProps): JSX.Element => (
                  <ProtocolFormShowEditState
                    protocol={protocol}
                    {...mobileContainerProps}
                    {...debouncingContainerProps}
                    {...editContainerProps}
                    {...rest}
                  />
                )}
              </ProtocolFormShowEditStateContainerEdit>
            )}
          </ProseMirrorDebouncingContainer>
        )}
      </Mobile>
    )}
  </EntityUpdateContainer>
);
